
import { defineComponent, onMounted, ref } from "vue";
import Top4StatsCard from "@/components/cards/Top4StatsCard.vue";
import SixMonthsData from "@/components/tables/SixMonthsData.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import ChartTest from "@/components/charts/Chart.vue";
import Chart2Test from "@/components/charts/Chart2.vue";
import { useStore } from "vuex";
import moment, { Moment } from "moment";

interface dataset {
  label: string;
  backgroundColor: string;
  borderColor: string;
  data: number[];
  borderWidth: number;
}
interface dataCollection {
  labels: string[];
  datasets: dataset[];
}

export default defineComponent({
  name: "dashboard",
  components: {
    ChartTest,
    Chart2Test,
    SixMonthsData,
    Top4StatsCard,
  },
  setup() {
    const store = ref(useStore());
    const dataString = ref<string>("[]");
    /* store.value.dispatch(Map.FINDCLOCKFORMAP, {}); */

    const datacollection = ref<dataCollection>({
      labels: ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7", "CN"],
      datasets: [
        {
          label: "Tuần " + moment().add(-1, "weeks").format("ww/yyyy"),
          backgroundColor: "rgba(54, 162, 235, 0.1)",
          data: [],
          borderColor: "#006f91",
          borderWidth: 0.5,
        },
        {
          label: "Tuần " + moment().format("ww/yyyy"),
          backgroundColor: "rgba(75, 192, 192, 0.5)",
          data: [],
          borderColor: "#00910c",
          borderWidth: 0.5,
        },
      ],
    });
    const datacollection1 = ref<dataCollection>({
      labels: ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7", "CN"],
      datasets: [
        {
          label: "Tuần " + moment().add(-1, "weeks").format("ww/yyyy"),
          backgroundColor: "rgba(54, 162, 235, 0.1)",
          borderColor: "#006f91",
          data: [],
          borderWidth: 0.5,
        },
        {
          label: "Tuần " + moment().format("ww/yyyy"),
          backgroundColor: "rgba(75, 192, 192, 0.5)",
          data: [],
          borderColor: "#00910c",
          borderWidth: 0.5,
        },
      ],
    });
    const datacollection2 = ref<dataCollection>({
      labels: ["Version 2.3", "Chưa cài app"],
      datasets: [
        {
          label: "SỐ LƯỢNG",
          backgroundColor: "rgba(54, 162, 235, 0.1)",
          borderColor: "#006f91",
          borderWidth: 0.5,
          data: [0, 1],
        },
      ],
    });

    const userVerify = ref<any>();
    const newsCount = ref<any>();
    const moneyRequest = ref<any>();
    const display = ref<boolean>();
    const display1 = ref<boolean>();
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
    return {
      store,
      dataString,
      datacollection,
      datacollection1,
      datacollection2,
      userVerify,
      newsCount,
      moneyRequest,
      display,
      display1,
    };
  },
  methods: {
    handleDataChange(val) {
      this.dataString = val;
    },

    getDayss(i = 0) {
      let startOfWeek = null as Moment | null;
      let endOfWeek = null as Moment | null;
      if (i == 0) {
        startOfWeek = moment().startOf("isoWeek");
        endOfWeek = moment().endOf("isoWeek");
      } else {
        startOfWeek = moment().startOf("isoWeek").add(-1, "weeks");
        endOfWeek = moment().endOf("isoWeek").add(-1, "weeks");
      }

      let days = [] as string[];
      let day = startOfWeek;

      while (day <= endOfWeek) {
        days.push(moment(day.toDate()).format("DD-MMM-yyyy"));
        day = day.clone().add(1, "d");
      }
      return days;
    },
  },
});
